import back from './icon-back.svg';
interface Icons {
  back: string;
}

export const icons: Icons = {
  back,
};
